import { Autosuggest, Modal, SpaceBetween } from '@cloudscape-design/components';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../pages/context/GlobalStateContext';


interface EquipmentPickerProps {
    visible: boolean;
    close?: boolean;
    clear?: boolean;
    title?: string;
    subTitle?: string;
    isBookCapable?: number;
    onDismiss: () => void;
    onConfirm: (selectedDate: string) => void;
}

type EquipmentItem = {
    idEquipment: number,
    isBookCapable: number,
    registration: string
    make: string
    model: string
    category: string
    idCategory: number
    value: string,
    label: string,
    description: string,
    tags: [],
    labelTag: string,
};
const EquipmentPicker: React.FC<EquipmentPickerProps> = ({
    visible,
    close = false,
    clear = true,
    title = 'Seleccione',
    subTitle = 'Recurso',
    isBookCapable = -1,
    onDismiss,
    onConfirm,
}) => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();
    const [keyw, setKeyw] = useState<string>('');

    const [equipments, setEquipments] = useState<EquipmentItem[]>([]);
    const autosuggestRef = useRef<HTMLDivElement>(null);
    const handleEquipmentSelect = ({ detail }: { detail: { value: string } }) => {
        onConfirm(detail.value);
        onDismiss();
    };
    useEffect(() => {
        if (data && data.equipments) {
            setEquipments(data.equipments.map((equipment: any) => ({
                idEquipment: equipment.idEquipment,
                registration: equipment.registration,
                make: equipment.make,
                category: equipment.category,
                isBookCapable: equipment.isBookCapable,
                model: equipment.model,
                value: equipment.idEquipment,
                label: equipment.registration,
                description: equipment.make + ' ' + equipment.model,
                //tags: ["CPU-v2", "2Gb RAM"],
                labelTag: equipment.category
            })));
        }
    }, [data?.equipments]);
    const filteredEquipments = keyw.trim().length >= 2
        ? equipments.filter(equipment => {
            const searchWords = keyw.trim().toLowerCase().split(/\s+/).filter(Boolean);
            const reg = equipment.registration.toLowerCase();
            const category = equipment.category.toLowerCase();
            const model = equipment.model.toLowerCase();
            const make = equipment.make.toLowerCase();
            const id = equipment.idEquipment.toString();

            const matchesKeyword = searchWords.every(word =>
                reg.includes(word) || id.includes(word) || category.includes(word) || model.includes(word) || make.includes(word)
            );
            const matchesBookCapable = isBookCapable === -1 || equipment.isBookCapable === isBookCapable;
            return matchesKeyword && matchesBookCapable;
        })
        : [];
    useEffect(() => {

    }, [keyw]);
    useEffect(() => {
        if (filteredEquipments.length === 1) {
            onConfirm(filteredEquipments[0].value);
            setKeyw("")
        }
    }, [filteredEquipments]);
    useEffect(() => {
        if (visible && autosuggestRef.current) {
            const input = autosuggestRef.current.querySelector('input');
            (input as HTMLInputElement | null)?.focus();
        }
    }, [visible])
    return (
        <Modal
            visible={visible}
            onDismiss={onDismiss}
            size="small"
            header={title}
        >
            <SpaceBetween direction="vertical" size="xs">
                <div ref={autosuggestRef}>
                    <Autosuggest
                        hideEnteredTextOption
                        onChange={({ detail }) => setKeyw(detail.value)}
                        onSelect={({ detail }) => {
                            if (detail.selectedOption) {
                                handleEquipmentSelect({ detail: { value: detail.selectedOption.value ?? '' } });
                            }
                        }}
                        value={keyw}
                        options={filteredEquipments}
                        ariaLabel="Autosuggest example with suggestions"
                        placeholder="Enter value"
                        filteringType="none"  // Important: disables built-in filtering
                    />
                </div>
            </SpaceBetween>
        </Modal >
    );
};

export default EquipmentPicker;